export default __webpack_public_path__ + "static/media/about-min.d3c14103.png";